if (!Element.prototype.closest) {
  Element.prototype.closest = function(selectors) {
    let elem = this;

    while (elem) {
      if (elem.matches(selectors)) {
        return elem;
      }
      elem = elem.parentElement;
    }
    return null;
  };
}
